import {StorePlayerColor, StoreItemCategory} from '../../entity_datas/StoreEnums'
import {BaseStoreItem} from '../BaseStoreItem'
import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'

export class SIColorGold extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.Gold
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.Gold'}
    price = 300000
    image = LobbyImage.StoreColorGold
    activeInStore = false
}

export class SIColorSilver extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.Silver
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.Silver'}
    price = 300000
    image = LobbyImage.StoreColorSilver
    activeInStore = false
}

export class SIColorBronze extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.Bronze
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.Bronze'}
    price = 300000
    image = LobbyImage.StoreColorBronze
    activeInStore = false
}

export class SIColorBlack extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.Black
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.Black'}
    price = 0
    image = LobbyImage.StoreColorBlack
    activeInStore = true
}

export class SIColorPurple extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.Purple
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.Purple'}
    price = 2500
    image = LobbyImage.StoreColorPurple
    activeInStore = true
}

export class SIColorMysticBlue extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.MysticBlue
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.MysticBlue'}
    price = 5000
    image = LobbyImage.StoreColorMysticBlue
    activeInStore = true
}

export class SIColorWhite extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.White
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.White'}
    price = 1000
    image = LobbyImage.StoreColorWhite
    activeInStore = true
}

export class SIColorPink extends BaseStoreItem {
    category = StoreItemCategory.Color
    type = StorePlayerColor.Pink
    name: TranslationObject = {key: 'strings:colonistCommon.playerColors.Pink'}
    price = 300000
    imagePath = LobbyImage.StoreColorPink
    activeInStore = false
}
